---
title: Your first task
lede: Write what has to be true when it is done, check the chips, and press Start.
order: 7
part: Get started
---

A task is the instruction an agent works from until it hands back. Starting one creates a session.

### Open the task form

Press **+** beside **Sessions** in the navigator. It offers three ways in, beside **New epic** for a larger piece of work (see [Epics](/epics)):

- **New task** (`⌘N`): a blank form.
- **Pull request** (`⌘⇧N`): start from an open pull request, once a git provider is set up. See [Pull requests](/pull-requests).
- **Investigate clipboard** (`⌘⌥N`): a stack trace or bug report on your clipboard becomes a written task, in the workspace whose repositories hold the files it names.

![The task form](media/newtask-form.webp)

### Write it like a ticket

The title is how you will find the session later. The body is the whole instruction: the agent will not come back with questions, so say what must be true when it is done.

Drop files onto the form, such as a screenshot or a log. They are copied into the sandbox, and an `@` path to each is added to the prompt.

### Check the chips

![The task chips](media/newtask-chips.webp)

The chips under the prompt read as a sentence about the task: the workspace, the priority (**In the queue** or **Urgent**), **One instruction**, **Agent proposes** or a [workflow](/workflows), the model and effort, **Micro-VM** or **This computer**, the [target](/targets) if a workspace has more than Local, the files, and the repositories and branches. Press one to change it for this task only. [The task form](/task-form) covers each chip; where the work lands is decided at the [merge](/merging).

### Start or queue

- **Start** (`⌘↩`) runs the task now. If every session slot is taken, it waits on the [board](/board) and starts as soon as one frees.
- **Queue** puts it on the board's backlog, where it waits until you move it to To do.

A form opened from the board offers **Add** instead. A task already written offers **Save**, and in the backlog also **Run**, which saves it and moves it to To do.

### What starting does

Each repository is cloned into the sandbox on a branch named `session/<id>`, cut from the source branch you chose (on this computer, a `git worktree` on that branch). The agent starts in the folder that holds them all.

A session starts with all its repositories or not at all. If one cannot be cloned, the start fails and the pane says which repository and why. **Retry** starts the whole session again; **Open repositories** takes you to the workspace's repositories, and **Close session** closes it.

Then do something else. Airlock tells you when the agent stops — see [Notifications](/notifications).
